var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"form-group"},[_c('label',{staticStyle:{"font-size":".9em"}},[_vm._v(_vm._s(_vm.label))]),_vm._v(" "),_c('multiselect',{attrs:{"disabled":_vm.disabled,"options":_vm.options,"multiple":true,"value":_vm.internalObjectValue,"label":"label","track-by":"value"},on:{"input":_vm.changed}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }